import { Children, cloneElement } from 'react';

import { useLetterheadGetQuery } from '../../Common/Queries/letterheadQueries';
import { useLocationGetQuery } from '../../Common/Queries/locationQueries';
import { useStreamGetQuery } from '../../Common/Queries/streamQueries';
import { useTemplateGetQuery } from '../../Common/Queries/templateQueries';
import { useUsersGetQuery } from '../../Common/Queries/usersQueries';

import { isLogin } from '../../utils';

import { ALL_DATA_LIMIT, DURATION_TIME } from '../../constants';

export function PositionFormContainer({ children, ...props }) {
  // Locations
  const locations = useLocationGetQuery({ limit: 0 });

  // Streams
  const streams = useStreamGetQuery(
    { limit: ALL_DATA_LIMIT },
    { enabled: isLogin(), refetchInterval: DURATION_TIME, refetchIntervalInBackground: true }
  );

  // userRoles
  const userRoles = useUsersGetQuery(
    { limit: ALL_DATA_LIMIT },
    { enabled: isLogin(), refetchInterval: DURATION_TIME, refetchIntervalInBackground: true }
  );

  const offerLetterTemplates = useTemplateGetQuery(
    { limit: ALL_DATA_LIMIT },
    { enabled: isLogin(), refetchInterval: DURATION_TIME, refetchIntervalInBackground: true }
  );

  const letterheadData = useLetterheadGetQuery({ enabled: isLogin() });

  return Children.only(
    cloneElement(children, {
      locations,
      streams,
      userRoles,
      offerLetterTemplates,
      letterheadData,
      ...props,
    })
  );
}
